import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 20 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <text x="0.5" y="4.5" fontSize="4" fill="currentColor">
      1.
    </text>
    <text x="0.5" y="9.5" fontSize="4" fill="currentColor">
      2.
    </text>
    <text x="0.5" y="14.5" fontSize="4" fill="currentColor">
      3.
    </text>
    <line x1="6" y1="4" x2="18" y2="4" strokeWidth="1.5" />
    <line x1="6" y1="9" x2="18" y2="9" strokeWidth="1.5" />
    <line x1="6" y1="14" x2="18" y2="14" strokeWidth="1.5" />
  </svg>
);
